import React, { useEffect } from "react";

import WidgetLoader from "@views/widgets/WidgetLoader";

const PLUGIN_KEY = "w_poi_content_manager";
export default function PoiContentManager() {
    useEffect(() => {
        WidgetLoader(PLUGIN_KEY);
    }, [])

    return (
        <div id={PLUGIN_KEY}> </div>
    );
}
